function isNullableString(value) {
    return value === null || typeof value === 'string';
}
export function isUserProfile(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    return (typeof candidate.uid === 'string' &&
        candidate.uid.length > 0 &&
        isNullableString(candidate.email) &&
        isNullableString(candidate.displayName) &&
        (candidate.role === 'user' || candidate.role === 'admin') &&
        (candidate.authProvider === 'password' ||
            candidate.authProvider === 'google' ||
            candidate.authProvider === 'apple' ||
            candidate.authProvider === 'telegram') &&
        isNullableString(candidate.telegramId) &&
        typeof candidate.createdAt === 'string' &&
        typeof candidate.updatedAt === 'string');
}
